<template>
  <section>
    <div id="partnersCont" :class="{'part-active': zoneIsActive, 'part-deactive': zoneNotActive}">
      <h2 :class="{'h2-active': zoneIsActive, 'h2-deactive': zoneNotActive}"><span>PARTNERS</span> OF OURS</h2>
      <div id="cardCont">
        <PartnersCard v-for="card in partnersCards" :key="card.title" :image="card.image" :title="card.title" :transDelay="card.transDelay" :link="card.link" />
      </div>
    </div>
  </section>
</template>

<script>
  import PartnersCard from '../cards/PartnersCard.vue'
  
  export default {
    name: 'PartnersSection',
    
    components: {
      PartnersCard
    },
    
    data() {
      return {
        partnersCards: [
          {
            title: 'Microsoft',
            image: require('@/assets/cardIcons/microsoft_280x120.svg'),
            link: 'https://www.microsoft.com',
            transDelay: '100ms'
          },
          {
            title: 'VMWare',
            image: require('@/assets/cardIcons/vmware_280x120.svg'),
            link: 'https://www.vmware.com',
            transDelay: '200ms'
          },
          {
            title: 'Veeam',
            image: require('@/assets/cardIcons/veeam_280x120.svg'),
            link: 'https://wcs-veeamproducts-bergenterprisesllc.swcontentsyndication.com/VeeamProduct-Homepage-EN',
            transDelay: '300ms'
          },
          {
            title: 'Fortinet',
            image: require('@/assets/cardIcons/fortinet_280x120.svg'),
            link: 'https://www.fortinet.com',
            transDelay: '400ms'
          },
          {
            title: 'Dell',
            image: require('@/assets/cardIcons/dell_280x120.svg'),
            link: 'https://www.dell.com',
            transDelay: '500ms'
          }
          ]
      }
    },
    
    computed: {
      zoneIsActive() {
        return this.$store.state.activeSections.partners;
      },
      zoneNotActive() {
        return !this.$store.state.activeSections.partners;
      }
    },
    
    methods: {
      
    }
  }
  
</script>

<style scoped>
  section {
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
    border: solid blue 0px;
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-main);
    transition: background-color, 400ms;
    color:rgb(0,0,0);
  }
  
  #partnersCont {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: dashed green 0px;
    transition: opacity 300ms cubic-bezier(.47,0,.2,1);
  }
  
  .part-active {
    opacity: 1;
  }
  
  .part-deactive {
    opacity: 0;
  }
  
  span {
    color: rgb(103, 35, 184);
    font-weight: bold;
  }

  h2 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 34px;
    border: solid yellow 0px;
    position: relative;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, .2);
    margin: 0px 0px 60px 0px;
    transition: all 500ms cubic-bezier(.47,0,.2,1);
  }
  
  .h2-active {
    opacity: 1;
    transform: scale(1);
  }
  
  .h2-deactive {
    opacity: 0;
    transform: scale(.8);
  }
  
  #cardCont {
    width: 100%;
    min-width: 320px;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    border: solid red 0px;
  }
  
  @media screen and (max-width: 800px) {
    #partnersCont {
      margin: 80px 0px 0px 0px;
    }
  }
  
  @media screen and (max-width: 450px) {
    h2 {
      font-size: 7vw;
      text-align: center;
      margin: 20px 0px 10px 0px;
    }
  }
</style>